import {
  ModuleLayout,
  ModuleType,
  CardBlockImage,
  ModuleContentBlocksContent,
  BonusObtainType,
  ModuleIcon,
  ModuleTopPrivacyTipsBlockContent,
} from "entities/modules/types";
import {
  defaultThreeCardBlock,
  defaultTopPrivacyTipsBlock,
} from "entities/modules/utils";
import { Translations } from "shared/types/languages";
import { create } from "zustand";

export type GeneralDataStore = {
  moduleName: string;
  moduleType: ModuleType | null;
  adminNotes: string;
  translations?: Translations;
  moduleLayout: ModuleLayout | null;
  studioFilterEnabled: boolean;
  baseUrl?: string;
  rows?: number;
  isInvalidBaseUrl: boolean;
  contentBlocks?: ModuleContentBlocksContent[];
  threeCardBlockImages: CardBlockImage[];
  oneCardBlockImage: CardBlockImage[];
  bonusObtainType?: BonusObtainType | null;
  iconShown: boolean;
  icon: ModuleIcon | null;
  topPrivacyTipsBlock: ModuleTopPrivacyTipsBlockContent;
  topPrivacyTipsBlockImage: CardBlockImage;
  setRows: (rows: number) => void;
  setModuleName: (moduleName: string) => void;
  setModuleType: (moduleType: ModuleType | null) => void;
  setAdminNotes: (adminNotes: string) => void;
  setTranslations: (translations: Translations) => void;
  setModuleLayout: (moduleLayout: ModuleLayout | null) => void;
  setStudioFilterEnabled: (enabled: boolean) => void;
  setBaseUrl: (baseUrl: string) => void;
  setInvalidBaseUrl: (isInvalidBaseUrl: boolean) => void;
  setContentBlocks: (contentBlocks?: ModuleContentBlocksContent[]) => void;
  setThreeCardBlockImages: (threeCardBlockImages: CardBlockImage[]) => void;
  setOneCardBlockImage: (oneCardBlockImage: CardBlockImage[]) => void;
  setBonusObtainType: (bonusObtainType: BonusObtainType | null) => void;
  setIconShown: (iconShown: boolean) => void;
  setIcon: (icon: ModuleIcon | null) => void;
  setTopPrivacyTipsBlock: (block: ModuleTopPrivacyTipsBlockContent) => void;
  setTopPrivacyTipBlockImage: (image: CardBlockImage) => void;
  clearGeneralData: () => void;
};

export const useGeneralData = create<GeneralDataStore>((set) => ({
  moduleName: "",
  moduleType: ModuleType.Games,
  adminNotes: "",
  translations: undefined,
  moduleLayout: null,
  studioFilterEnabled: false,
  baseUrl: "",
  isInvalidBaseUrl: false,
  contentBlocks: defaultThreeCardBlock(),
  threeCardBlockImages: [null, null, null],
  oneCardBlockImage: [null],
  bonusObtainType: null,
  rows: 1,
  iconShown: false,
  icon: null,
  topPrivacyTipsBlock: defaultTopPrivacyTipsBlock(),
  topPrivacyTipsBlockImage: null,
  setRows: (rows) => set({ rows }),
  setModuleName: (moduleName) => set({ moduleName }),
  setModuleType: (moduleType) => set({ moduleType }),
  setAdminNotes: (adminNotes) => set({ adminNotes }),
  setTranslations: (translations) => set({ translations }),
  setModuleLayout: (moduleLayout) => set({ moduleLayout }),
  setStudioFilterEnabled: (studioFilterEnabled) => set({ studioFilterEnabled }),
  setBaseUrl: (baseUrl) => set({ baseUrl }),
  setInvalidBaseUrl: (isInvalidBaseUrl) => set({ isInvalidBaseUrl }),
  setContentBlocks: (contentBlocks) => set({ contentBlocks }),
  setThreeCardBlockImages: (threeCardBlockImages) =>
    set({ threeCardBlockImages }),
  setOneCardBlockImage: (oneCardBlockImage) => set({ oneCardBlockImage }),
  setBonusObtainType: (bonusObtainType) => set({ bonusObtainType }),
  setIconShown: (iconShown) => set({ iconShown }),
  setIcon: (icon) => set({ icon }),
  setTopPrivacyTipsBlock: (topPrivacyTipsBlock) => set({ topPrivacyTipsBlock }),
  setTopPrivacyTipBlockImage: (topPrivacyTipsBlockImage) =>
    set({ topPrivacyTipsBlockImage }),
  clearGeneralData: () =>
    set({
      moduleName: "",
      moduleType: ModuleType.Games,
      adminNotes: "",
      translations: undefined,
      moduleLayout: null,
      studioFilterEnabled: false,
      isInvalidBaseUrl: false,
      baseUrl: "",
      contentBlocks: defaultThreeCardBlock(),
      threeCardBlockImages: [null, null, null],
      oneCardBlockImage: [null],
      bonusObtainType: null,
      iconShown: false,
      icon: null,
    }),
}));
